/**
 * Admin authentication utilities for PIN-protected admin routes
 */

const ADMIN_SESSION_KEY = 'admin_session';
const ADMIN_SESSION_DURATION = 7 * 24 * 60 * 60 * 1000; // 7 days

export function getAdminPin(): string {
	return '973919';
}

export function isAdminAuthenticated(): boolean {
	const sessionData = localStorage.getItem(ADMIN_SESSION_KEY);
	if (!sessionData) return false;

	try {
		const { timestamp } = JSON.parse(sessionData);
		const now = Date.now();
		// Check if session is still valid
		if (now - timestamp > ADMIN_SESSION_DURATION) {
			localStorage.removeItem(ADMIN_SESSION_KEY);
			return false;
		}
		return true;
	} catch {
		return false;
	}
}

export function authenticateAdmin(pin: string): boolean {
	const correctPin = getAdminPin();
	if (!correctPin) {
		console.error('VITE_ADMIN_PIN not set in environment');
		return false;
	}

	if (pin === correctPin) {
		localStorage.setItem(
			ADMIN_SESSION_KEY,
			JSON.stringify({ timestamp: Date.now() })
		);
		return true;
	}
	return false;
}

export function logoutAdmin(): void {
	localStorage.removeItem(ADMIN_SESSION_KEY);
}

